import {baseService} from './baseService';

export const sellerService = {
    listGroups,
    names,
    summary
};

function listGroups() {
    return baseService.get(encodeURI('api/seller/groups'));
}

function names() {
    return baseService.get(encodeURI('api/seller/names'));
}

function summary(date) {
    return baseService.get(encodeURI('api/seller/summary?date=' + date));
}